export default {
  common: {
    save: 'Salva',
    cancel: 'Annulla',
    confirm: 'Conferma',
    delete: 'Elimina',
    edit: 'Modifica',
    view: 'Visualizza',
    back: 'Indietro',
    close: 'Chiudi',
    add: 'Aggiungi',
    send: 'Invia',
    sending: 'Invio...',
    saving: 'Salvataggio...',
    loading: 'Caricamento...',
    search: 'Cerca',
    update: 'Aggiorna',
    create: 'Crea',
    creating: 'Creazione...',
    transfer: 'Trasferisci',
    approve: 'Approva',
    reject: 'Rifiuta',
    ok: 'Capito',
    name: 'Nome',
    username: 'Nome utente',
    password: 'Password',
    email: 'E-mail',
    date: 'Data',
    status: 'Stato',
    type: 'Tipo',
    quantity: 'Quantità',
    description: 'Descrizione',
    project: 'Progetto',
    task: 'Attività',
    logout: 'Esci',
    notifications: 'Notifiche',
    settings: 'Impostazioni',
    draft: 'Bozza',
    sent: 'Inviato',
    active: 'Attivo',
    inactive: 'Inattivo',
    priority: 'Priorità',
    language: 'Lingua',
    yes: 'Sì',
    no: 'No',
    error: 'Errore',
    success: 'Successo',
    warning: 'Attenzione',
    required: 'Obbligatorio',
    optional: 'Facoltativo',
    all: 'Tutti',
    none: 'Nessuno',
    upload: 'Carica file',
    download: 'Scarica',
    print: 'Stampa',
    actions: 'Azioni',
    details: 'Dettagli',
    filters: 'Filtri',
    results: 'Risultati',
    noResults: 'Nessun risultato trovato',
    total: 'Totale',
    of: 'di',
    verified: 'verificato',
    pending: 'In attesa',
    completed: 'Completato',
    cancelled: 'Annullato',
  },

  auth: {
    login: 'Accedi',
    loginTitle: 'Accedi al tuo account',
    logout: 'Esci',
    register: 'Registrati',
    forgotPassword: 'Password dimenticata?',
    resetPassword: 'Reimposta password',
    usernameOrEmail: 'Nome utente o e-mail',
    enterPassword: 'Inserisci la password',
    enterUsername: 'Inserisci il nome utente',
    loginError: 'Nome utente o password errati.',
    sessionExpired: 'Sessione scaduta. Accedi nuovamente.',
  },

  nav: {
    dashboard: 'Pannello di controllo',
    overview: 'Panoramica',
    documents: 'Documenti',
    viewDocuments: 'Visualizza documenti',
    manageProjects: 'Gestisci progetti',
    viewProjects: 'Visualizza progetti',
    manageUsers: 'Gestisci utenti',
    viewUsers: 'Visualizza utenti',
    manageWarehouse: 'Gestisci magazzino',
    viewWarehouse: 'Visualizza magazzino',
    manageMachinery: 'Gestisci macchinari',
    viewMachinery: 'Visualizza macchinari',
    manageSystem: 'Gestisci sistema',
    projects: 'Progetti',
    myProjects: 'I miei progetti',
    myTasks: 'Le mie attività',
    reports: 'Rapporti',
    drawings: 'Disegni',
    warehouse: 'Magazzino',
    checkStock: 'Controlla scorte',
    requests: 'Richieste',
    requestItem: 'Richiedi articolo',
    tickets: 'Ticket',
    messages: 'Messaggi',
    adminMode: 'Modalità amministratore',
    standardMode: 'Modalità standard',
    analystMode: 'Modalità analista',
    createReport: 'Crea rapporto',
    createReports: 'Rapporti di cantiere',
    dailyReport: 'Rapporto giornaliero di cantiere',
    incidentReport: 'Rapporto di incidente',
    safetySection: 'Sicurezza sul lavoro',
    safetyDialog: 'Dialoghi di sicurezza',
    workPermit: 'Permesso di lavoro critico',
    occurrenceReport: 'Rapporto di accadimento',
    settingsMenu: 'Impostazioni',
  },

  profile: {
    editProfile: 'Modifica profilo',
    displayName: 'Nome',
    usernameLabel: 'Nome utente',
    passwordLabel: 'Password',
    changePassword: 'Cambia password',
    appearance: 'Aspetto',
    lightMode: 'Modalità chiara',
    darkMode: 'Modalità scura',
    languageLabel: 'Lingua',
    cropTitle: 'Ritaglia foto profilo',
    cropUse: 'Usa questa area',
    zoom: 'Zoom',
    currentPassword: 'Conferma password attuale',
    newPassword: 'Nuova password',
    confirmNewPassword: 'Conferma nuova password',
    emailVerified: 'verificato',
    emailChange: 'Modifica',
    emailSendCode: 'Invia codice',
    emailConfirm: 'Conferma',
    emailResend: '← Reinvia codice',
    emailCancelChange: 'Annulla',
    emailSending: 'Invio...',
    emailVerifying: 'Verifica...',
    emailHint: 'Codice inviato a {email}. Controlla la posta in arrivo e lo spam.',
    emailSuccess: 'E-mail {email} verificata con successo.',
    emailInvalidError: 'Inserisci un\'e-mail valida.',
    emailGenericError: 'Errore durante l\'invio del codice.',
    emailInvalidCode: 'Codice non valido.',
    passwordFillAll: 'Compila tutti i campi per il cambio password.',
    passwordWrong: 'La password attuale non è corretta.',
    passwordMismatch: 'La conferma della nuova password non corrisponde.',
    saveFillAll: 'Compila nome e nome utente.',
    saveFinishPassword: 'Completa o annulla il cambio password prima di salvare.',
    avatarAlt: 'profilo',
  },

  dashboard: {
    overview: 'Panoramica',
    myProjects: 'I miei progetti',
    myTasks: 'Le mie attività',
    activeProjects: 'Progetti attivi',
    completedTasks: 'Attività completate',
    pendingTasks: 'Attività in sospeso',
    recentActivity: 'Attività recente',
    noProjects: 'Nessun progetto trovato.',
    noTasks: 'Nessuna attività trovata.',
    createProject: 'Crea progetto',
    projectName: 'Nome del progetto',
    startDate: 'Data di inizio',
    endDate: 'Data di fine',
  },

  projects: {
    title: 'Progetti',
    newProject: 'Nuovo progetto',
    projectName: 'Nome del progetto',
    startDate: 'Inizio',
    endDate: 'Fine',
    progress: 'Avanzamento',
    team: 'Team',
    gantt: 'Pianificazione',
    files: 'File',
    tickets: 'Ticket',
    warehouse: 'Magazzino',
    dds: 'Dialogo sicurezza',
    reports: 'Rapporti',
    noProjects: 'Nessun progetto.',
    deleteConfirm: 'Sei sicuro di voler eliminare questo progetto?',
  },

  tasks: {
    title: 'Attività',
    newTask: 'Nuova attività',
    taskName: 'Nome attività',
    assignee: 'Responsabile',
    dependencies: 'Dipendenze',
    duration: 'Durata (giorni)',
    startDate: 'Inizio',
    endDate: 'Fine',
    progress: 'Avanzamento',
    addProgress: 'Registra avanzamento',
    noTasks: 'Nessuna attività.',
    blocked: 'Bloccata',
    inProgress: 'In corso',
    done: 'Completata',
    deleteConfirm: 'Eliminare questa attività?',
  },

  warehouse: {
    title: 'Magazzino',
    stock: 'Scorte',
    requestItem: 'Richiedi articolo',
    requests: 'Richieste',
    addItem: 'Aggiungi articolo',
    itemName: 'Nome articolo',
    category: 'Categoria',
    unit: 'Unità',
    available: 'Disponibile',
    reserved: 'Riservato',
    transferItem: 'Trasferisci articolo',
    reportDamage: 'Segnala danno',
    provideEquipment: 'Fornisci attrezzatura',
    noItems: 'Nessun articolo in magazzino.',
    noRequests: 'Nessuna richiesta.',
    approveRequest: 'Approva richiesta',
    rejectRequest: 'Rifiuta richiesta',
    requestStatus: {
      pending: 'In attesa',
      approved: 'Approvato',
      rejected: 'Rifiutato',
      delivered: 'Consegnato',
    },
  },

  safety: {
    title: 'Sicurezza',
    dds: 'Dialogo sicurezza',
    ddsTitle: 'Dialogo quotidiano di sicurezza',
    newDds: 'Nuovo dialogo',
    occurrences: 'Accadimenti',
    permits: 'Permessi',
    createDialog: 'Crea dialogo',
    createOccurrence: 'Registra accadimento',
    createPermit: 'Crea permesso',
    topic: 'Argomento',
    presenter: 'Presentatore',
    attendees: 'Partecipanti',
    date: 'Data',
    noSafety: 'Nessun registro di sicurezza.',
  },

  tickets: {
    title: 'Ticket',
    newTicket: 'Nuovo ticket',
    subject: 'Oggetto',
    category: 'Categoria',
    openedBy: 'Aperto da',
    assignedTo: 'Assegnato a',
    openTickets: 'Ticket aperti',
    closedTickets: 'Ticket chiusi',
    noTickets: 'Nessun ticket.',
    status: {
      open: 'Aperto',
      inProgress: 'In corso',
      closed: 'Chiuso',
    },
  },

  users: {
    title: 'Utenti',
    newUser: 'Nuovo utente',
    role: 'Ruolo',
    roles: {
      adminMaster: 'Admin principale',
      adminObra: 'Admin cantiere',
      user: 'Utente',
    },
    noUsers: 'Nessun utente.',
    deleteConfirm: 'Eliminare questo utente?',
    manageRoles: 'Gestisci ruoli',
    manageUsers: 'Gestione utenti',
    userList: 'Elenco utenti',
  },

  system: {
    title: 'Impostazioni di sistema',
    siteName: 'Nome del sistema',
    logo: 'Logo',
    loginBackground: 'Sfondo di accesso',
    primaryColor: 'Colore principale',
    save: 'Salva impostazioni',
    saved: 'Impostazioni salvate.',
  },

  reports: {
    title: 'Rapporti',
    daily: 'Rapporto giornaliero',
    incident: 'Rapporto di incidente',
    noReports: 'Nessun rapporto.',
    createReport: 'Crea rapporto',
    date: 'Data',
    author: 'Autore',
    content: 'Contenuto',
  },

  machinery: {
    title: 'Macchinari pesanti',
    newMachine: 'Nuovo macchinario',
    machineName: 'Nome',
    model: 'Modello',
    plate: 'Targa',
    status: 'Stato',
    noMachinery: 'Nessun macchinario.',
  },

  messenger: {
    title: 'Messaggi',
    newMessage: 'Nuovo messaggio',
    noMessages: 'Nessun messaggio.',
    typeMessage: 'Scrivi un messaggio...',
    send: 'Invia',
  },
}
